module.exports = __webpack_public_path__ + "static/media/biontech_naswiz.a958d368.jpeg";